export const transformPackageSizeDto = _ref => {
  let {
    code,
    custom,
    education_text,
    format_description,
    id,
    standard,
    title,
    weight_description,
    image
  } = _ref;
  return {
    code,
    custom,
    educationText: education_text,
    formatDescription: format_description,
    id,
    standard,
    title,
    weightDescription: weight_description,
    image
  };
};
export const transformPackageSizesDto = package_sizes => package_sizes.map(transformPackageSizeDto);